<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Cadastrar Usuário</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="name">Nome</label>
            <input
              id="name"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.name.value"
            />
            <span v-if="state.name.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="name">Status</label>
            <select id="name" class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
            <span v-if="state.name.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="name">Admin</label>
            <select id="name" class="form-select" v-model="state.admin">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
            </select>
            <span v-if="state.name.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-4">
            <label for="name">Colaborador</label>
            <select id="name" class="form-select" v-model.number="state.colaborador">
              <option value="" disabled>Selecione</option>
              <option
                v-for="colaborador in state.colaboradores"
                :key="colaborador.id"
                :value="colaborador.id"
              >
                {{ colaborador.nome }}
              </option>
            </select>
            <span v-if="state.name.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              class="form-control"
              placeholder="Digite um email:"
              v-model="state.email.value"
            />
            <span v-if="state.email.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-4">
            <label for="password">Senha</label>
            <input
              id="password"
              type="password"
              class="form-control"
              placeholder="Digite uma senha:"
              v-model="state.password.value"
            />
            <span v-if="state.password.error" class="text-danger"
              >Este campo é obrigatório /
            </span>
            <span v-if="state.caracter" class="text-danger"
              >O campo password deve ter no mínimo 8 caracteres.</span
            >
          </div>
        </div>
        <div class="row">
          <div class="btns_right">
            <button @click="salvarUsuario" type="button" class="btn_save">
              Salvar
            </button>
            <router-link to="/admin/usuarios">
              <button type="button" class="btn_cancel">Cancelar</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      name: {
        value: "",
        error: false,
      },
      email: {
        value: "",
        error: false,
      },
      password: {
        value: "",
        error: false,
      },
      status: "ATIVO",
      admin: "NAO",
      caracter: false,
      colaboradores: [],
      colaborador: "",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.veiculo == "VEICULO") {
        state.modo = "VEICULO";
      }
      if (router.currentRoute._value.params.id != undefined) {
        fetchUsuario();
      }
      fetchColaboradores();
    });

    function debugState() {
      console.log("Estado atual:", {
        colaborador_id: state.colaborador,
        colaborador_type: typeof state.colaborador,
        colaboradores: state.colaboradores,
        all_state: state,
      });
    }

    async function fetchUsuario() {
      try {
        const { data } = await services.usuario.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.name.value = data.name;
        state.email.value = data.email;
        state.admin = data.admin;
        state.status = data.status;
        state.colaborador = data.colaborador_id;
      } catch (error) {
        console.log(error);
      }
    }

    async function fetchColaboradores() {
      try {
        const { data } = await services.colaboradores.getAll({ token });
        state.colaboradores = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarUsuario() {
      debugState();

      var erro_validacao = false;

      if (state.name.value.length == 0) {
        state.name.error = true;
        erro_validacao = true;
      }
      if (state.email.value.length == 0) {
        state.email.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }

      if (!state.id) {
        if (state.password.value.length == 0) {
          state.password.error = true;
          erro_validacao = true;
        }
        if (state.password.value.length < 8) {
          state.caracter = true;
          return;
        }
        await services.usuario
          .save({
            name: state.name.value,
            email: state.email.value,
            password: state.password.value,
            status: state.status,
            admin: state.admin,
            colaborador_id: state.colaborador,
            token,
          })
          .then((data) => {
            console.log(data);
            router.push({ name: "Usuarios" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        if (state.password.value.length > 3) {
          var senha = state.password.value;
        }

        await services.usuario.update({
          id: state.id,
          name: state.name.value,
          email: state.email.value,
          password: senha,
          status: state.status,
          admin: state.admin,
          colaborador_id: state.colaborador,
          token,
        });
        router
          .push({ name: "Usuarios" })
          .then((data) => {
            router.push({ name: "Usuarios" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    return {
      salvarUsuario,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

.label_check {
  font-weight: normal;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #0a516d;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #0a516d;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #0a516d;
}

.btns_right {
  text-align: right;
  margin-top: 5rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  color: #fff;
  background: #56008f;
  border: solid 2px #56008f;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  filter: brightness(1.5);
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background-color: transparent;
  color: #56008f;
  border: solid 2px #56008f;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #56008f;
  color: #fff;
  filter: brightness(1.5);
}

.imagem {
  width: 100%;
  object-fit: cover;
  margin-top: 1rem;
}

.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: #8b0000;
  color: #fff;
  border: solid 1px #8b0000;
  border-radius: 5px;
  transition: 0.3s;
  margin-top: 1rem;
}

.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>
